import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=7563018c&scoped=true&"
import script from "./Announcements.vue?vue&type=script&lang=ts&"
export * from "./Announcements.vue?vue&type=script&lang=ts&"
import style0 from "./Announcements.vue?vue&type=style&index=0&id=7563018c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7563018c",
  null
  
)

export default component.exports